import PropTypes from 'prop-types';
import React from 'react';
import { StringUtils } from '@components/UtilComponents/UtilFunctions';

import BrText from '@components/BrText';

export default function MetadataTextColumn({ row }) {
  return (
    <div className="br-table-editor-metadata-type-column">
      <div className="title">
        <span title={row.Original_Data.name || ''}>
          <BrText>{row.Original_Data.name || ''}</BrText>
        </span>
      </div>
      <div className="metadata-rows">
        <div className="key">
          <span>Widget Id</span>
        </div>
        <div className="value">
          <span>{row.Original_Data.widgetHash || ''}</span>
        </div>
      </div>
      <div className="metadata-rows">
        <div className="key">
          <span>Widget Type</span>
        </div>
        <div className="value">
          <span>{StringUtils.capitalizeFirstLetter(row.Original_Data.algorithm.displayName) || ''}</span>
        </div>
      </div>
    </div>
  );
}

MetadataTextColumn.propTypes = {
  row: PropTypes.shape({
    Original_Data: PropTypes.any,
  }).isRequired,
  cell: PropTypes.shape({
    // cell data
    value: PropTypes.any,
  }).isRequired,
};
